import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'The user archives a workspace agent thread from My Tasks',
  name: 'agent_thread_archived',
  params: [WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM],
};

export default META;
